module.exports = __webpack_public_path__ + "img/package2.ecb1754d.png";